<template>
    <div class="item">
        <div class="check-cont">
            <el-checkbox v-model="mainAddressChecked" @change="changeMain($event)" :checked="true" v-if="data2.main_adress === 1"></el-checkbox>
            <el-checkbox v-model="mainAddressChecked" @change="changeMain($event)" :checked="false" v-if="data2.main_adress === 0" ></el-checkbox>
            <div class="bg-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="26.049" height="25.814" viewBox="0 0 26.049 25.814">
                <path id="Path_3813" data-name="Path 3813" d="M5045.045-19485.148c-.527,1.859-.437,6.586-.59,9.594s-.309,11.18.463,12.514,9.044.045,11.858,0,10.585.252,11.111-1.5a25.112,25.112,0,0,0,.321-7.691c-.194-3.16-.042-10.977-1.138-12.578s-8.656-1.031-11.869-1.3S5045.571-19487.008,5045.045-19485.148Z" transform="translate(-5043.273 19487.354)" fill="none" stroke="#bacb32" stroke-width="2"/>
                </svg>
            </div>
            <div class="check-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14.066" height="14.174" viewBox="0 0 14.066 14.174">
                <g id="Group_1852" data-name="Group 1852" transform="matrix(0.978, 0.208, -0.208, 0.978, -291.853, -423.135)">
                    <path id="Path_218" data-name="Path 218" d="M.426,1.166C2.573.7,4.748,1.208,6.9.912c.547-.075.866-1.005.129-.9C4.876.3,2.706-.2.555.263.02.378-.308,1.325.426,1.166Z" transform="matrix(0.829, 0.559, -0.559, 0.829, 376.489, 359.997)" fill="#bacb32" stroke="#bacb32" stroke-width="1"/>
                    <path id="Path_220" data-name="Path 220" d="M12.139.1a12.457,12.457,0,0,1-5,.486C5.169.5,3.2.389,1.255.125.332,0-.669,1.055.6,1.227a56.735,56.735,0,0,0,7.106.5A13.976,13.976,0,0,0,12.973.99C14.133.528,13.094-.281,12.139.1Z" transform="translate(386.839 351.98) rotate(109)" fill="#bacb32" stroke="#bacb32" stroke-width="1"/>
                </g>
                </svg>
            </div>
        </div>
        <div class="data-cont">
            <button class="change light-italic" @click="openSlide">{{ $fn.tr('ცვლილების გაკეთება') }}</button>
            <p class="name bold-italic">{{ _.get(data2, 'name') }}</p>
            <p class="country light-italic">{{ _.get(data2, 'city') }}</p>
            <p class="city light-italic">{{ _.get(data2, 'street') }}</p>
            <p class="phone light-italic">ტელეფონი: {{ _.get(data2, 'phone') }}</p>
            <slide-up-down :active="active" :duration="600">
            <div class="add-form">
            <form @submit.prevent="sendDataValid" novalidate>
            <div class="inp">
                <input type="text" v-model="data.name" placeholder="სახელი და გვარი" />
                <transition name="fade">
                <p class="err regular" v-if="data.err.nameErr">{{ $fn.tr('შეიყვანეთ სახელი და გვარი!') }}</p>
                </transition>
            </div>
            <div class="inp">
                <input type="text" @keypress="dontNum($event)" v-model="data.phone" placeholder="ტელ.ნომერი" />
                <transition name="fade">
                <p class="err regular" v-if="data.err.phoneErr">{{ $fn.tr('შეიყვანეთ ტელ.ნომერი!') }}</p>
                </transition>
            </div>
            <div class="inp-select">
            <el-select v-model="data.citys" :placeholder="$fn.tr('ქალაქი')">
                <el-option
                v-for="item in city_list"
                :key="item.id"
                :label="item.title"
                :value="item.slug"
                >
                </el-option>
            </el-select>
            <transition name="fade">
                <p class="err regular" v-if="data.err.citysErr">{{ $fn.tr('შეიყვანეთ ქალაქი!') }}</p>
            </transition>
            </div>
            <div class="inp">
                <input type="text" v-model="data.adress" placeholder="მისამართი" />
                <transition name="fade">
                <p class="err regular" v-if="data.err.adressErr">{{ $fn.tr('შეიყვანეთ მისამართი!') }}</p>
                </transition>
            </div>
            <div class="but-cont">
            <button class="save">
                <img src="@/assets/img/buybtn.png" />
                <p class="regular">{{ $fn.tr('შენახვა') }}</p>
            </button>
            </div>
            </form>
            </div>
            </slide-up-down>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data2', 'id'],
    data() {
        return {
            active: null,
            checked: false,
            mainAddressChecked: 0,
            data: {
                name: '',
                phone: '',
                citys: '',
                adress: '',

                err: {
                    nameErr: false,
                    phoneErr: false,
                    citysErr: false,
                    adressErr: false,
                }
            }
        }
    },
    mounted() {
        if (_.get(this.data2, 'main_adress') === 1) {
            this.checked = true
        }
    },
     watch: {
        active(){
               setTimeout(() => {
               this.$store.state.main.updateLs = !this.$store.state.main.updateLs
            }, 620);
        },
    },
    computed: {
        city_list() {
            return this.$store.state.main.indx.terms.customer_cities;
        }
    },
    methods: {
        dontNum(event) {  
        if (event.keyCode == 46 || event.keyCode == 8)
        {
        //do nothing
        }
        else 
        {
            if (event.keyCode < 48 || event.keyCode > 57 ) 
            {
			    event.preventDefault();	
			}	
        }
        },
        sendDataValid() {
            if (this.data.name === '') {
                this.data.err.nameErr = true
            } else if (this.data.phone === '') {
                this.data.err.phoneErr = true
            } else if (this.data.citys === '') {
                this.data.err.citysErr = true
            } else if (this.data.adress === '') {
                this.data.err.adressErr = true
            } else {
                this.data.err.nameErr = false
                this.data.err.phoneErr = false
                this.data.err.citysErr = false
                this.data.err.adressErr = false
                this.changeAdress()
                this.active = null
            }
        },
        async changeAdress() {
            this.$emit('dropped', null);
            let data = {};
            data.name = this.data.name;
            data.phone = this.data.phone;
            data.city = this.data.citys;
            data.street = this.data.address;
            data.house = this.data2.house;
            data.street = this.data2.street;
            data.entrance = this.data2.entrance;
            data.floor = this.data2.floor;
           
            data.main_adress = this.mainAddressChecked;
            data.id = this.id;

            let tmp =  await this.$fn.postData('user/editaddress',{data:data, token:localStorage.userToken});

            // console.log(tmp)
            this.$store.commit("main/changeAddress", tmp.data.success);
            this.$emit('clicked', null)
            this.$store.state.main.adressCartsRender = false
            setTimeout(() => {
            this.$store.state.main.adressCartsRender = true
                // console.log(tmp)
            }, 600);
        },
        async changeMain(e) {
            console.log(this.$store.state.main.currentAdress)
         if(this.mainAddressChecked === 0){
             this.mainAddressChecked === 1;
         } else if (this.mainAddressChecked === 1){
             this.mainAddressChecked === 0
         }

         if (e) {
            this.$store.state.main.currentAdress = this.data2
            // console.log(this.$store.state.main.currentAdress)
         } else {
             this.$store.state.main.currentAdress = null
         }
            let data = {};
            data.name = this.data2.name;
            data.phone = this.data2.phone;
            data.city = this.data2.city;
            data.street = this.data2.street;
            data.house = this.data2.house;
            data.entrance = this.data2.entrance;
            data.floor = this.data2.floor;
           
            data.main_adress = this.mainAddressChecked;
            data.id = this.id;  

            let tmp =  await this.$fn.postData('user/editaddress',{data:data, token:localStorage.userToken});
            // console.log(tmp)
            this.$store.commit("main/changeAddress", tmp.data.success);
            // console.log(this.mainAddressChecked)
            this.$emit('clicked', null)
            this.$emit('clickedMainAddress', null)
            this.$store.state.main.adressCartsRender = false
            setTimeout(() => {
            this.$store.state.main.adressCartsRender = true
                // console.log(tmp)
            }, 600);
      
        },
        openSlide() {
            this.active = !this.active
            this.data.name = _.get(this.data2, 'name')
            this.data.phone = _.get(this.data2, 'phone')
            this.data.citys = _.get(this.data2, 'city')
            this.data.adress = _.get(this.data2, 'street')
        }
    }
}
</script>
